// 住宅ローンしっかり審査事前審査申込同意不同意（受付完了）（連帯債務者等用）
import React from 'react';
import TopArea from '../../molecules/TopArea';
import PreliminaryReviewNewContentInquiryFinalBody from './PreliminaryReviewNewContentInquiryFinalBody';
import MypageReturn from '../../molecules/MypageReturn';

interface Props {
  reception_cd: string;
  label: string;
  status_name: string;
}

const PreliminaryReviewNewContentInquiryFinal: React.FC<Props> = ({
  label,
  status_name,
  reception_cd,
}) => {
  return (
    <>
      <TopArea
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={false}
        guide_text={''}
        display_status={false}
      />
      <PreliminaryReviewNewContentInquiryFinalBody />
      <MypageReturn is_staff={false} />
    </>
  );
};

export default PreliminaryReviewNewContentInquiryFinal;
